import React from "react";
import NumberFire from "@fdr/static-ui/SvgImages/NumberFire";
import Text from "@fdr/atomic-ui/_atoms/Text";
import DerbyPick, { Props as DerbyPickProps } from "../../_molecules/DerbyPick";
import {
  Container,
  PicksWrapper,
  SmartPlays,
  InfoWrapper,
  NumberFireIcon,
  NumberFirePredictions
} from "./styled-components";

export interface Props {
  // Derby picks array
  picks: Array<DerbyPickProps>;
  // if the picks are number fire predicts
  isNumberFire?: boolean;
  // base bet for payout
  baseBet?: number;
}

const DerbyPicks = ({ picks, isNumberFire = false, baseBet = 10 }: Props) => (
  <Container data-qa-label="derby-picks">
    <SmartPlays>
      <InfoWrapper>
        <NumberFirePredictions>
          {isNumberFire ? (
            <>
              <NumberFireIcon>
                <NumberFire />
              </NumberFireIcon>
              <Text>PREDICTS</Text>
            </>
          ) : (
            <Text>RUNNERS</Text>
          )}
        </NumberFirePredictions>

        {isNumberFire ? (
          <Text>${baseBet} BET POT. PAYOUT</Text>
        ) : (
          <Text>ODDS</Text>
        )}
      </InfoWrapper>
    </SmartPlays>
    <PicksWrapper>
      {picks.map((pick) => (
        <DerbyPick {...pick} key={pick.runnerId} />
      ))}
    </PicksWrapper>
  </Container>
);

export default DerbyPicks;
